import { Link, redirect, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from "../Footer/Footer";
import icon02 from "../../../screenassets/images/cta/02.png";
import { useEffect, useState } from 'react';
import { ToastContainer, toast, } from "react-toastify";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { fetchUsers, setUser, userDetails } from '../../../service/slice/AuthSlice';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import md5 from 'md5';


export default function Signin() {

    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const userlogin = useSelector((state) => state.userSlice?.value);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (userlogin) {
            navigate("/")
        }
    }, [])

    function validatePassword(password) {
        const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return re.test(password);
    };

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();

        const loginData = {
            email: email,
            password: password,
        }

        if (!email) {
            toast.info("Please enter your email or phone number!");
            return;
        }
        if (!validatePassword(password)) {
            toast.info("Password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }
        if (!isChecked) {
            toast.info("Please accept terms and conditions!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loginData),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Signin successful!");
                localStorage.setItem("authToken", data.token);
                dispatch(fetchUsers({ token: data.token, type: "user" }))
                // navigate('/user/dashboard');
                window.location.href = "/user/dashboard";
            } else if (data.status === false && data.userVerified === "otpnotverified") {
                navigate('/registerValidateOtp', { state: loginData });

            } else {
                toast.error("Invalid Email ID or password!");
                navigate("/signin");
            }

            // Clear fields on success
            setEmail('');
            setPassword('');

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }



    const handleSigninGoogle = async (email, password) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password
                }),
            });
            return response.json();

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }
    const handleSignUpGoogle = async (userDetails) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/registerPartials`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    first_name: userDetails.first_name,
                    last_name: userDetails.last_name,
                    email: userDetails.email,
                    password: userDetails.password
                }),
            });
            return response.json();

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }

    const onSuccess = (credentialResponse) => {
        const user = jwtDecode(credentialResponse.credential);
        var userDetails = {
            first_name: user?.given_name,
            last_name: user?.family_name,
            email: user?.email,
            password: md5(user?.sub)
        }

        handleSigninGoogle(userDetails.email, userDetails.password).then((data) => {
            if (data.status === true) {
                toast.success("Signin successful!");
                localStorage.setItem("authToken", data.token);
                dispatch(fetchUsers({ token: data.token, type: "user" }))
                window.location.href = "/user/dashboard";
            } else {
                if (data.userVerified === "notverified") {
                    handleSignUpGoogle(userDetails).then((res) => {
                        const userEmail = userDetails.email;
                        const OTP = res.otp
                        if (res.status) {
                            navigate('/googleVerified', { state: { email: userEmail, otp: OTP } });
                        }
                    }).catch((error) => {

                    })
                } else if (data.userVerified === "detailsnotverified") {
                    const OTP = data.otp
                    const userEmail = userDetails.email;
                    navigate('/googleVerified', { state: { email: userEmail, otp: OTP } });
                }
                //navigate("/googleVerified");
            }
        }).catch((err) => {

        })


    };


    const onFailure = (error) => {
        console.log('Login Failed:', error);
        // Handle login failure
    };


    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Log In</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Log In</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Form Section */}
            <div className="log-in-area-start rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="single-form-s-wrapper">
                                <div className="head">
                                    <span>Welcome Back</span>
                                    <h5 className="title">Login to continue</h5>
                                </div>

                                <div className="body">
                                    <form onSubmit={(event) => { handleSubmit(event) }}>
                                        <div className="input-wrapper">
                                            <input type="email" id='email' name='email' value={email} onChange={(event) => { setEmail(event.target.value) }} placeholder="Email" Style="border:none !important" required />
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <input type={showPassword ? "text" : "password"} id='password' name='password' value={password} onChange={(event) => { setPassword(event.target.value) }} placeholder="Password" className="pr-10" Style="border:none !important" required />

                                            {/* Toggle button */}
                                            <button type="button" onClick={() => setShowPassword(!showPassword)} className="passwordShow">
                                                {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                            </button>
                                        </div>

                                        <div className="check-wrapper">
                                            <div className="form-check">
                                                <input className="form-check-input d-none" type='checkbox' checked={isChecked} onChange={handleCheckboxChange} id="flexCheckDefault" />
                                                <label className="form-check-label" htmlFor="flexCheckDefault">Accept <Link data-bs-toggle="modal" data-bs-target="#staticBackdrop">Terms and Conditions.</Link></label>
                                            </div>
                                            <Link to="/forgot">Forgot password?</Link>
                                        </div>

                                        <button type="submit" className="rts-btn btn-primary text-white">Sing In</button>
                                        <p>Don't have an account? <Link className="ml--5" to="/signup">Sign Up for Free</Link></p>
                                    </form>
                                </div>
                                <div className="other-separator">
                                    <span>or</span>
                                </div>
                                <div className="sign-in-otherway">
                                    <GoogleLogin onSuccess={onSuccess} onError={onFailure} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div className="rts-cta-area rts-section-gapBottom  bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary text-white">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="staticBackdropLabel">Modal title</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <header>
                                <h1>Terms &amp; Conditions</h1>
                                <p class="muted">Effective date: <strong>[Effective Date]</strong> — For: <strong>[Platform Name]</strong></p>
                            </header>


                            <section>
                                <h2>1. Introduction</h2>
                                <p>These Terms &amp; Conditions ("Terms") govern your access to and use of the AI-based question solving platform operated by <strong>[Platform Name]</strong> ("we", "us", "the Platform"). By using the Platform you agree to these Terms. If you do not agree, do not use the Platform.</p>
                            </section>


                            <section>
                                <h2>2. Definitions</h2>
                                <ul>
                                    <li><strong>Student / User:</strong> a person who accesses or uses the Platform.</li>
                                    <li><strong>Package:</strong> a paid subscription, bundle, or credit pack that grants access to additional features beyond the free allowance.</li>
                                    <li><strong>Request:</strong> a single submission to the Platform asking the AI to solve, explain, or generate an answer for one question or problem.</li>
                                </ul>
                            </section>


                            <section>
                                <h2>3. Free Usage — 3 Free Requests</h2>
                                <p class="highlight">Unregistered or non-purchased users are entitled to <strong>three (3) free requests</strong> total. After exhausting these free requests, further use of the Platform requires purchasing a Package or creating an account as described below.</p>
                                <ol>
                                    <li>Free requests are tracked per-user via cookies and/or account identifier (if any). We reserve the right to limit or reset tracking to prevent abuse.</li>
                                    <li>Free requests are intended for trial and evaluation only and may be subject to lower priority, rate limits, or reduced feature access compared to paid Packages.</li>
                                    <li>We may change the number or nature of free requests at our discretion; continued use of the Platform after such change constitutes acceptance of the change.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>4. Paid Packages, Billing &amp; Access</h2>
                                <ol>
                                    <li>Packages: Paid Packages grant access to a specified number of requests, higher priority processing, or additional features described on the Platform's pricing page.</li>
                                    <li>Payment: All fees are charged in the currency shown at checkout. Payment methods accepted are displayed at the time of purchase.</li>
                                    <li>Auto-renewal: If a Package is subscription-based, it will renew automatically at the end of each billing cycle unless cancelled by the User before renewal. You may cancel subscription auto-renewal from your account settings.</li>
                                    <li>No transfer: Credits, requests, or access included with a Package are non-transferable unless explicitly stated otherwise.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>5. Refund &amp; Cancellation Policy</h2>
                                <ol>
                                    <li>Refunds: Refund eligibility (if any) depends on the Package purchased and the jurisdiction. Unless otherwise provided, purchases are non-refundable after requests have been consumed or if the Platform has delivered the paid service.</li>
                                    <li>How to cancel: To cancel a subscription or stop auto-renewal, follow the cancellation steps in your account or contact us at <a href="mailto:[support@example.com]">[support@example.com]</a>.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>6. Use of AI-Generated Solutions</h2>
                                <ol>
                                    <li>Accuracy: AI-generated solutions are provided for educational purposes only. We do not guarantee that any solution is correct, complete, or suitable for any particular purpose.</li>
                                    <li>Verification: Students must verify solutions before relying on them for exams, assignments, or any graded work. Using Platform output as-is for academic submissions may violate your institution's policies — you are responsible for complying with those policies.</li>
                                    <li>Plagiarism: The Platform's outputs may resemble existing content. It is the User's responsibility to ensure proper citation and to avoid plagiarism when required by academic rules.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>7. Intellectual Property</h2>
                                <ol>
                                    <li>Ownership: The Platform and its content, including AI models, code, designs, and documentation, are owned or licensed by the Platform.</li>
                                    <li>User submissions: By submitting questions, you grant us a worldwide, royalty-free, non-exclusive license to use the submitted content to provide, improve, and analyze the Platform's services. We will not publish personally-identifying information without consent except as required by law.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>8. Prohibited Conduct</h2>
                                <p>Users must not use the Platform to:</p>
                                <ul>
                                    <li>Attempt to reverse-engineer the AI or its outputs.</li>
                                    <li>Use automated scripts to bypass the free-request limits or otherwise manipulate the service.</li>
                                    <li>Submit content that is unlawful, harmful, discriminatory, or violates others' rights.</li>
                                </ul>
                            </section>


                            <section>
                                <h2>9. Suspension, Termination &amp; Abuse</h2>
                                <p>We reserve the right to suspend or terminate access for users who violate these Terms or engage in abusive behaviour. In cases of fraud or abuse, we may revoke free requests, cancel Packages, or refer the matter to appropriate authorities. We are not liable for any losses from such enforcement actions.</p>
                            </section>


                            <section>
                                <h2>10. Disclaimers &amp; Limitation of Liability</h2>
                                <ol>
                                    <li>DISCLAIMER: THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE". TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</li>
                                    <li>LIMITATION OF LIABILITY: TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THESE TERMS OR THE PLATFORM SHALL NOT EXCEED THE AMOUNTS PAID BY YOU IN THE PRIOR 12 MONTHS (IF ANY). WE ARE NOT LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>11. Privacy &amp; Data</h2>
                                <p>Your use of the Platform is also governed by our <a href="[Privacy Policy URL]">Privacy Policy</a>. We collect and process certain information (such as device identifiers, cookies, and content submitted by you) to operate and improve the Platform. Please review the Privacy Policy for details about data retention, deletion, and your privacy rights.</p>
                            </section>


                            <section>
                                <h2>12. Changes to Terms</h2>
                                <p>We may revise these Terms from time to time. We will provide notice of material changes via the Platform or email. Continued use after notice constitutes acceptance of the updated Terms.</p>
                            </section>


                            <section>
                                <h2>13. Governing Law &amp; Dispute Resolution</h2>
                                <p>These Terms are governed by the laws of <strong>[Jurisdiction — e.g., State/Country]</strong> without regard to conflict-of-law rules. Any dispute arising from these Terms will be resolved in the courts located in <strong>[City, State/Country]</strong>, unless otherwise agreed in writing.</p>
                            </section>

                            <section>
                                <h2>14. Contact</h2>
                                <p>If you have questions about these Terms, contact us at:</p>
                                <div>
                                    <strong>[Platform Name]</strong><br />
                                    Email: <a href="mailto:[support@example.com]">[support@example.com]</a><br />
                                    Address: [Company Address — optional]
                                </div>
                            </section>

                            <footer>
                                <p class="muted">Last updated: <strong>[Last Updated Date]</strong>. Please read these Terms carefully. Your access and use are conditioned on accepting and complying with them.</p>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Section */}
            <Footer />


        </>
    )
}
